<ng-container *ngIf="job.state !== DistributionJobState.SENT">

    <div class="row no-gutters">
        <div class="col-sm-12">
            <email-chips #to_chips
                         [idPrefix]="(idPrefix + 'to')"
                         [label]="job.trans.email_to"
                         [required]="isCaseDistributionJob"
                         [disabled]="disabled"
                         [addresses]="job.email_to"
                         (addressesChange)="onChange('email_to', $event)"
                         (validated)="to_addressesInvalid = !$event">
            </email-chips>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-sm-12 text-right">
            <button id="{{idPrefix}}btn.show_cc_bcc"
                    class="cc-bcc-btn iq-link-style"
                    mat-icon-button
                    style="width: 55px;"
                    *ngIf="!disabled"
                    (click)="showCCAndBCC()">
                {{ (job.trans.email_cc | translate | uppercase) + '/' + (job.trans.email_bcc | translate | uppercase) }}
            </button>
        </div>
    </div>

    <div class="row no-gutters" *ngIf="ccAndBccVisible">
        <div class="col-sm-12">
            <email-chips [label]="job.trans.email_cc"
                         [idPrefix]="(idPrefix + 'cc')"
                         [disabled]="disabled"
                         [addresses]="job.email_cc"
                         (addressesChange)="onChange('email_cc', $event)"
                         (validated)="cc_addressesInvalid = !$event">
            </email-chips>
        </div>
    </div>

    <div class="row no-gutters" *ngIf="ccAndBccVisible">
        <div class="col-sm-12">
            <email-chips [label]="job.trans.email_bcc"
                         [idPrefix]="(idPrefix + 'bcc')"
                         [disabled]="disabled"
                         [addresses]="job.email_bcc"
                         (addressesChange)="onChange('email_bcc', $event)"
                         (validated)="bcc_addressesInvalid = !$event">
            </email-chips>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-sm-12">
            <mat-form-field class="full-width">
                <mat-label>{{ job.trans.email_subject | translate }}</mat-label>
                <input id="{{idPrefix}}{{job.trans.email_subject}}"
                       type="text" matInput
                       [(ngModel)]="job.email_subject"
                       (blur)="onChange('email_subject', job.email_subject)"
                       [disabled]="disabled"
                       [required]="true"
                />
            </mat-form-field>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-sm-12">
            <smp-ck-editor [idPrefix]="idPrefix"
                           [idSuffix]="'email_body'"
                           [bananaBox]="job.email_body"
                           (bananaBoxChange)="onChange('email_body', $event)"
                           [disabled]="disabled">
            </smp-ck-editor>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="job.state === DistributionJobState.SENT">
    <div class="p-4">
        <div class="row">
            <div class="col-sm-4 col-lg-2">
                <strong>{{ job.trans.email_to | translate}}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ job.email_to }}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-lg-2">
                <strong>{{ job.trans.email_cc | translate}}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ job.email_cc || '-' }}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-lg-2">
                <strong>{{ job.trans.email_bcc | translate}}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ job.email_bcc || '-' }}</span>
            </div>
        </div>

        <div class="row mt-1">
            <div class="col-sm-4 col-lg-2">
                <strong>{{ job.trans.email_subject | translate}}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ job.email_subject }}</span>
            </div>
        </div>

        <div class="row mt-1">
            <div class="col-sm-4 col-lg-2">
                <strong>{{ job.trans.email_body | translate}}: </strong>
            </div>
            <div class="col-sm-8 col-lg-10">
                <span>{{ job.email_body | drRemoveHtmlTags }}</span>
            </div>
        </div>
    </div>
</ng-container>
